import { useEffect, useState } from "react";
import { getClubs } from "../../js/database";
import { getCurrentDay } from "../../js/getLiveClass";
import { timeString } from "../../js/generateSchedule";

function ClubCenter() {
    const [clubSchedule, setClubSchedule] = useState([]);

    useEffect(() => {
        getClubs().then((clubs) => {
            var monday = new Date();
            monday.setDate(monday.getDate() - monday.getDay());
            if (new Date().getDay() === 6) monday.setDate(monday.getDate() + 7);
            var schedule = [];
            for (var i = 0; i < 5; i++) {
                var date = new Date(monday.setDate(monday.getDate() + 1));
                schedule.push({date:date, day:getCurrentDay(date), clubs:[]});
            }
            
            Object.entries(clubs).forEach(([clubName, club]) => {
                Object.values(club.meetings).forEach((meeting) => {
                    schedule.forEach((day, i) => {
                        if (meeting.type === "weekly") {
                            if (i == meeting.day) {
                                day.clubs.push({name:clubName, meeting:meeting, color:club.color});
                            }
                        } else if (meeting.type === "cyclic") {
                            if (day.day == meeting.day) {
                                day.clubs.push({name:clubName, meeting:meeting, color:club.color});
                            }
                        } else if (meeting.type === "one-time") {
                            if (day.date.getTime() == new Date(meeting.day + " CDT").getTime()) {
                                day.clubs.push({name:clubName, meeting:meeting, color:club.color});
                            }
                        }
                    })
                })
            })

            schedule.forEach((day) => {
                day.clubs.sort((a, b) => {
                    return parseFloat(a.meeting.time.start.replace(":", ".") - parseFloat(b.meeting.time.start.replace(":", ".")))
                })
            })
            setClubSchedule(schedule);
            })

        }
    , [])

    if (clubSchedule.length === 0) return <div></div>

    return (
        <div className="club-center row px-0 mx-0">
            {clubSchedule.map((day) => (
                <div className="col">
                    <h4>{day.date.toDateString().split(" ").slice(0, 3).join(" ")}<br/>Day {day.day+1}</h4>
                    <div class="d-flex">
                        <ul class="mx-auto justify-content-center">
                            {day.clubs.map((club) => (
                                <li><div class="card mt-4" style={{width: "15rem", backgroundColor:club.color}}>
                                    <div class="card-body">
                                        <h5 class="card-title text-center">{club.name}</h5>
                                        <p class="card-text text-center mb-0">{timeString([club.meeting.time.start, club.meeting.time.end])}</p>
                                        <p class="card-text text-center">Meets {club.meeting.type === "weekly" ? "Weekly" : club.meeting.type === "cyclic" ? "Cyclically" : "One Time"}</p>
                                    </div>
                                </div></li>
                            ))}
                        </ul>
                    </div>
                </div>
            ))}
        </div>
                                    
    )
}

export default ClubCenter;